import { Injectable,Inject } from '@angular/core';
import { BaseDO } from './base.model';

export class VehiclePriceDO {

public parentObject: String = null;

public versionId: String = null;

public guid: String = null;

public createdDt: String = null;

public updatedDt: String = null;

public createdUser: String = null;

public updatedUser: String = null;

public caseManager: String = null;

public exceptionDOList: String = null;

public id: String = null;

public makeCd: String = null;

public modelCd: String = null;

public variantCd: String = null;

public manufacturingYear: String = null;

public price: String = null;

 

}